import { object, string } from 'yup';

import { regExpLettersNumbersUnderscoreHyphen } from '@constants/regExp';
import {
	getMaxLengthErrMsg,
	mandatoryErrMessage,
} from '@constants/validationConstants';
import { MAX_500_LENGTH } from '@constants/validationMessages';

export const schema = object({
	name: string()
		.trim()
		.required(mandatoryErrMessage('Name'))
		.matches(regExpLettersNumbersUnderscoreHyphen, { message: 'The name must start with a letter, contain only alphanumeric characters or underscores' }),
	notes: string()
		.trim()
		.max(MAX_500_LENGTH, getMaxLengthErrMsg('Notes', MAX_500_LENGTH)),
});
